import {shopModule} from '../module.js';
import {AdrOptions, AdrConstants, CartService, AdrService, PaymentType} from '@nuskin/ns-shop';
import {RunConfigService, events} from '@nuskin/ns-util';
import {getCachedConfigField} from '@nuskin/configuration-sdk';
import {getStrings} from './stringUtil';

shopModule.service('nsAdrUtil', ['nsADRType', 'nsAdrOptions',
    function(nsADRType, nsAdrOptions) {
        let adrOptions = null;

        async function getAdrOptionsWithShipDays(payemtTypeId) {
            await getAdrOptions();
            loadAdrShipDays(payemtTypeId);
            return adrOptions;
        }

        async function getAdrOptions() {
            let runConfig = RunConfigService.getRunConfig(),
                tdc,
                contractLengths = [];

            tdc = await getStrings();

            if (!adrOptions || adrOptions.get(AdrConstants.ADR_MODE) == AdrConstants.BASIC_OPTIONS ||
                adrOptions.get(AdrConstants.COUNTRY) != runConfig.country || adrOptions.validTill < Date.now()) {
                adrOptions = new AdrOptions({
                    country: runConfig.country,
                    language: runConfig.language,
                    validTill: Date.now() + (10 * 60 * 1000)
                });

                adrOptions.set(AdrConstants.ADR_TYPE, nsADRType.NO_SELECTION_TYPE);
                adrOptions.set(AdrConstants.ADR_MODE, getCachedConfigField('adrMode'));
                adrOptions.set(AdrConstants.USE_DFLT_FOR_IMMEDIATE_FIRST, getCachedConfigField('useDfltShipDayFirst'));
                adrOptions.set(AdrConstants.USE_DFLT_FOR_IMMEDIATE_RECUR, getCachedConfigField('useDfltShipDayRecur'));
                adrOptions.set(AdrConstants.SHOW_CONTRACT_LENGTHS, getCachedConfigField('showContractLengths'));
                adrOptions.set(AdrConstants.FUTURE_DATES_NEXT_MONTH, getCachedConfigField('futureDatesStartNextMonth'));
                adrOptions.set(AdrConstants.ALLOW_SI_RECURRING_DATE_CHANGE, getCachedConfigField('allowSIRecurDateChange'));
                adrOptions.set(AdrConstants.SHIP_ALWAYS_WITH_ASSESSMENT, getCachedConfigField('shipAlwaysWithAssessment'));
                adrOptions.set(AdrConstants.SHIP_ALWAYS_WITH_CALIBRATION, getCachedConfigField('shipAlwaysWithCalibration'));

                const cfgContractLengths = getCachedConfigField('contractLengths');
                if (cfgContractLengths) {
                    let defaultSet = false,
                        // HK wants to now always show Agelocme Loyalty Contract. This hack makes it easy to go
                        // back to how it was before in case they change their mind.
                        adrHasAgelocMe = CartService.adrHasAgelocMe() || true;

                    cfgContractLengths.forEach((contractLength) => {
                        let cl = JSON.parse(contractLength),
                            clObj = {
                                value: cl.length,
                                contractType: cl.contractType,
                                displayText: tdc.selectContractLengthText.replace('{months}', cl.length)
                            },
                            skipItem = false;
                        if (clObj.contractType.toLowerCase() === AdrConstants.HK_ageLoc_Loyalty) {
                            if (adrHasAgelocMe) {
                                clObj = {
                                    value: cl.length,
                                    contractType: cl.contractType,
                                    displayText: tdc.agelocLoyaltyContractText.replace('{months}', cl.length)
                                };
                            } else {
                                skipItem = true;
                            }
                        }
                        if (!skipItem) {
                            contractLengths.push(clObj);
                            if (cl.isDefault) {
                                defaultSet = true;
                                adrOptions.set(AdrConstants.CONTRACT_LENGTH, clObj);
                            }
                        }
                    });
                    adrOptions.set(AdrConstants.CONTRACT_LENGTHS, contractLengths);
                    if (!defaultSet && contractLengths.length > 0) {
                        adrOptions.set(AdrConstants.CONTRACT_LENGTH, contractLengths[0]);
                    }
                }
            }

            return adrOptions;
        }

        function loadAdrShipDays(paymentTypeId) {
            let qualifier = paymentTypeId === PaymentType.SDD ? 'directdebit' : '';

            if (adrOptions && (!nsADRType.equals(adrOptions.get(AdrConstants.ADR_TYPE)) ||
                adrOptions.get(AdrConstants.QUALIFIER) != qualifier)) {
                adrOptions.set(AdrConstants.ADR_TYPE, nsADRType.getADRType());
                adrOptions.set(AdrConstants.QUALIFIER, qualifier);
                nsAdrOptions.getOptions(adrOptions).then(function(_adrOptions) {
                    adrOptions = _adrOptions;
                    events.publish(events.shop.ADR_SHIP_DAYS_CHANGED);
                });
            }
        }

        function loadBasicShipDays() {
            if (adrOptions && !nsADRType.equals(AdrConstants.BASIC, adrOptions.get(AdrConstants.ADR_TYPE))) {
                adrOptions.set(AdrConstants.ADR_MODE, AdrConstants.BASIC_OPTIONS);
                adrOptions.set(AdrConstants.ADR_TYPE, AdrConstants.BASIC);
                nsAdrOptions.getOptions(adrOptions).then(function(_adrOptions) {
                    adrOptions = _adrOptions;
                    events.publish(events.shop.ADR_SHIP_DAYS_CHANGED);
                });
            }
        }

        async function showAdrShipWhen() {
            let retVal = false,
                adr = AdrService.getAdrDraft(),
                adrOptions = adr && adr.fromCart ? await getAdrOptions() : null;
            if (adrOptions) {
                switch (adrOptions.get(AdrConstants.ADR_MODE)) {
                    case AdrConstants.IMMEDIATE_FUTURE:
                        nsADRType.setADRType(adr.shipImmediate ? AdrConstants.IMMEDIATE : AdrConstants.FUTURE);
                        retVal = true;
                        break;
                    case AdrConstants.DEFAULT_ALWAYS:
                        nsADRType.setADRType(adr.shipImmediate ? AdrConstants.DEFAULT : AdrConstants.ALWAYS);
                        retVal = true;
                        break;
                    case AdrConstants.IMMEDIATE_ONLY:
                        adrOptions.set(AdrConstants.IMMEDIATE);
                        loadAdrShipDays();
                        nsADRType.setADRType(AdrConstants.IMMEDIATE);
                        retVal = false;
                        break;
                }
                adr.fromCart = false;
                AdrService.setAdrDraft(adr);
            }

            return retVal;
        }


        return {
            getAdrOptions,
            getAdrOptionsWithShipDays,
            loadAdrShipDays,
            loadBasicShipDays,
            showAdrShipWhen
        }
    }]);
